module.exports = __webpack_public_path__ + "static/OklahomaStandard-Badge-White-692db75bc18105b6a4c214dca8984fd5.svg";